import { Fragment } from 'react';

import { Calendar, EmailTrigger, FileArrivalTrigger, FormulaIcon, PipelineTrigger, Refresh } from 'basic-components/icons';
import { DataScienceEnums } from 'dashboard-services/api/dataScience';

export const getTriggerTypeIcon = (name, color, size) => {
  switch(name) {
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.EMAIL:
      return (
        <EmailTrigger
            color={color}
            height={size}
            width={size}
        />
      )
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.FILE_ARRIVAL:
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.PROVIDER_FILE_ARRIVAL:
      return (
        <FileArrivalTrigger
            color={color}
            height={size}
            width={size}
        />
      )
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.PIPELINE:
      return (
        <PipelineTrigger
            color={color}
            height={size}
            width={size}
        />
      )
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.RETRY:
      return (
        <Refresh
            color={color}
            height={size}
            width={size}
        />
      )
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.FORMULA_SYMBOL:
      return (
        <FormulaIcon
            color={color}
            height={size}
            width={size}
        />
      )
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.CRON:
    case DataScienceEnums.PIPELINE_TRIGGER_TYPE.SCHEDULER:
      return (
        <Calendar
            color={color}
            height={size}
            width={size}
        />
      )
    default:
      return (
        <Fragment/>
      )
  }
}